<template>
    
    <div class="h-screen w-screen lg:max-w-2xl lg:mx-auto flex flex-col justify-center items-center">

        <img src="images/logotipo-la-tienda-de-valentina.jpg">
        
        <div class="h-auto w-full flex flex-col">
            
            <Request
                model="Auth"
                action="login"
                :form="form"
                @success="onSuccess"
                @error="onError"
                v-slot="{ request,loading }"
                class="w-full">

                <div @keypress.enter="request" class="h-full flex flex-col justify-center items-center px-4">

                    <input type="email" v-model="form.email"  placeholder="Email" class="w-full h-auto py-1 px-2 rounded-lg border-2 border-gray-500">
                    <input type="password" v-model="form.password" placeholder="Password" class="w-full h-auto py-1 px-2 rounded-lg mt-2 border-2 border-gray-500">

                    <button
                            @click="request"
                            class="w-full px-4 py-1 bg-blue-500 font-medium text-white rounded-lg mt-8"
                            :class="{ 'opacity-50': loading }"
                            :disabled="loading">
                        Login
                    </button>

                </div>

            </Request>

        </div>

    </div>

</template>

<script>
    import { Request } from '@/api/components';
    import { actions, state } from '@/store';

    export default {
        name: 'Login',
        components: {
            Request
        },
        data() {
            return {
                form: {
                    email: '',
                    password: ''
                }
            };
        },
        methods: {
            onSuccess(response) {
                actions.setUser(response.data)
                actions.setToken(response.api_token);
                this.$router.push({ name: 'home' });
            },
            onError(error) {
                console.log('failed', error);
            }
        }
    }
</script>

